
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

interface UserEnrollmentsSectionProps {
  enrollments: Array<{
    id: string;
    course: {
      course_name: string;
    };
    progress: number;
    status: string;
    payment_status: string;
    registered_at: string;
  }>;
  isLoadingEnrollments: boolean;
}

export function UserEnrollmentsSection({ enrollments, isLoadingEnrollments }: UserEnrollmentsSectionProps) {
  console.log('UserEnrollmentsSection - Raw enrollments data:', enrollments);
  
  // Filter to ensure we only work with valid enrollment objects that have complete data
  const validEnrollments = enrollments.filter(enrollment => 
    enrollment && enrollment.course && enrollment.payment_status
  );
  
  console.log('UserEnrollmentsSection - Valid enrollments data:', validEnrollments);
  
  // Create a sorted list with paid enrollments first
  const sortedEnrollments = [...validEnrollments].sort((a, b) => {
    // Paid enrollments first
    if (a.payment_status === 'Paid' && b.payment_status !== 'Paid') return -1;
    if (a.payment_status !== 'Paid' && b.payment_status === 'Paid') return 1;
    
    // Then sort by registration date (newest first)
    return new Date(b.registered_at).getTime() - new Date(a.registered_at).getTime();
  });
  
  return (
    <Card>
      <CardContent className="p-6">
        <h3 className="text-lg font-semibold mb-4">Course Enrollments</h3>
        <div className="space-y-6">
          {isLoadingEnrollments ? (
            <p className="text-sm text-muted-foreground">Loading enrollments...</p>
          ) : sortedEnrollments.length > 0 ? (
            sortedEnrollments.map((enrollment) => (
              <div key={enrollment.id} className="space-y-2 pb-4 border-b last:border-0">
                <p className="font-medium">{enrollment.course?.course_name || 'Unknown Course'}</p>
                <div className="text-sm space-y-1">
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Progress</span>
                    <span>{enrollment.progress}%</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Status</span>
                    <Badge variant={enrollment.status === 'Completed' ? 'success' : 'default'}>
                      {enrollment.status}
                    </Badge>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Payment</span>
                    <Badge 
                      variant={
                        enrollment.payment_status === 'Paid' ? 'success' : 
                        enrollment.payment_status === 'Refunded' ? 'secondary' : 
                        'outline'
                      }
                    >
                      {enrollment.payment_status}
                    </Badge>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-muted-foreground">Registered</span>
                    <span>{new Date(enrollment.registered_at).toLocaleDateString()}</span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-sm text-muted-foreground">No courses enrolled</p>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
